import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { RequestCountyFormFields, RequestCountyPayload } from './types';
import { RequestCountyProps } from '../types';

const useController = ({ onClose }: RequestCountyProps) => {
  const { handleSubmit, watch } = useFormContext<RequestCountyFormFields>();
  const { runRequest } = useRunRequest();
  const { id: workerId } = useParams<{ id: string }>();

  const state = watch('drivers_license_state');

  const handleRequest = async (values: RequestCountyFormFields) => {
    const { county, date_of_birth, drivers_license_state, first_name, last_name, provider } = values;

    const payload: RequestCountyPayload = {
      county,
      date_of_birth,
      first_name,
      last_name,
      state: drivers_license_state,
      ...(provider && { provider: `${provider}` }),
    };

    await runRequest({
      fetchType: 'CREATE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: workerId,
        target: TurnTargetsEnum.CountyCheck,
        data: payload,
      },
      mode: 'notify',
      notify: {
        onError: { message: 'Error: County Search was not initiated' },
        onSuccess: { message: 'County Check Requested Successfully', postAction: onClose },
      },
    });
  };

  return {
    handleRequest: handleSubmit(handleRequest),
    state,
  };
};

export default useController;
